import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { OrderActions  } from '../../../actions';
import QRScanner from '../../../components/QRScanner';

class Scan extends Component {
  constructor(props) {
    super(props);

    this.handleScan = this.handleScan.bind(this);
  }

  handleScan(values) {
    const { dispatch } = this.props;

    return dispatch(OrderActions.scanIn(values.scan)).then(() => {
      browserHistory.push('/dispatcher/inbound');
    });
  }

  render() {
    return (<div>
      <QRScanner onSubmit={this.handleScan} />
    </div>);
  }
}

export default connect()(Scan);;


// WEBPACK FOOTER //
// ./src/containers/Dispatcher/Inbound/Scan.js